/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * HackStalker.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { fetchApi } from "../../../fetch";
import type {
  AnalyzePublicGitHubRepoParams,
  AnalyzePublicRepoParams,
  CodeAnalysisDto,
  CodeAnalysisId,
  GetAnalysisStatusParams,
  GitHubComRepoDto,
} from "../../models";

export const getAnalyzePublicRepoUrl = (params?: AnalyzePublicRepoParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `/analysis/public-repo?${normalizedParams.toString()}`
    : `/analysis/public-repo`;
};

export const analyzePublicRepo = async (
  analyzePublicRepoBody: string,
  params?: AnalyzePublicRepoParams,
  options?: RequestInit,
): Promise<CodeAnalysisId> => {
  return fetchApi<CodeAnalysisId>(getAnalyzePublicRepoUrl(params), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(analyzePublicRepoBody),
  });
};

export const getAnalyzePublicGitHubRepoUrl = (params?: AnalyzePublicGitHubRepoParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `/analysis/public-github-repo?${normalizedParams.toString()}`
    : `/analysis/public-github-repo`;
};

export const analyzePublicGitHubRepo = async (
  gitHubComRepoDto: GitHubComRepoDto,
  params?: AnalyzePublicGitHubRepoParams,
  options?: RequestInit,
): Promise<CodeAnalysisId> => {
  return fetchApi<CodeAnalysisId>(getAnalyzePublicGitHubRepoUrl(params), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(gitHubComRepoDto),
  });
};

export const getGetAnalysisStatusUrl = (analysisId: number, params?: GetAnalysisStatusParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `/analysis/${analysisId}?${normalizedParams.toString()}`
    : `/analysis/${analysisId}`;
};

export const getAnalysisStatus = async (
  analysisId: number,
  params?: GetAnalysisStatusParams,
  options?: RequestInit,
): Promise<CodeAnalysisDto> => {
  return fetchApi<CodeAnalysisDto>(getGetAnalysisStatusUrl(analysisId, params), {
    ...options,
    method: "GET",
  });
};
